import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatedImageSection } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import { useGetBottomSignUpBannerImages } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/useGetBottomSignUpBannerProducts";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled, { css } from "styled-components";
export var BottomSignUpBannerImages = function() {
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTablet = _useViewport.isTablet, isDesktop = _useViewport.isDesktop;
    var rotatingBannerImages = useGetBottomSignUpBannerImages();
    var getImageDimensions = function(dimensions) {
        if (isMobile) {
            return dimensions.mobile;
        } else if (isTablet) {
            return dimensions.tablet;
        } else if (isDesktop) {
            return dimensions.desktop;
        } else {
            return dimensions.xlarge;
        }
    };
    return /*#__PURE__*/ _jsx(ImagesWrapper, {
        children: rotatingBannerImages.map(function(imageData, index) {
            return /*#__PURE__*/ _jsx(AnimatedImageSection, {
                $index: index,
                children: imageData.images.map(function(image, imageIndex) {
                    var imageDimensions = getImageDimensions(image.dimensions);
                    return /*#__PURE__*/ _jsx(StyledImage, {
                        src: image.src,
                        style: {
                            height: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height
                        },
                        height: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height,
                        $top: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.top,
                        $right: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.right,
                        $bottom: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.bottom,
                        $left: imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.left,
                        loading: "lazy",
                        alt: "",
                        $index: imageIndex
                    }, image.src);
                })
            }, imageData.keyword);
        })
    });
};
var ImagesWrapper = styled.div.withConfig({
    componentId: "sc-a20bfd58-0"
})([
    "position:relative;overflow:hidden;",
    "{width:264px;padding:0 ",
    ";height:400px;}",
    "{width:100%;height:440px;}",
    "{height:566px;}",
    "{height:631px;}"
], responsiveMediaQueries.mobile, getSpacing("7x"), responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktop, responsiveMediaQueries.xLargeAndAbove);
var StyledImage = styled.img.withConfig({
    componentId: "sc-a20bfd58-1"
})([
    "position:absolute;",
    " ",
    "{display:",
    ";}"
], function(props) {
    return css([
        "top:",
        ";right:",
        ";bottom:",
        ";left:",
        ";"
    ], props === null || props === void 0 ? void 0 : props.$top, props === null || props === void 0 ? void 0 : props.$right, props === null || props === void 0 ? void 0 : props.$bottom, props === null || props === void 0 ? void 0 : props.$left);
}, responsiveMediaQueries.mobile, function(props) {
    return props.$index === 0 || props.$index === 1 ? "none" : "block";
});
